<div class="phone-input-wrapper">
  <div class="phone-input">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" color="accent" style="width: fit-content">
      <mat-select [formField]="phoneForm.country">
        @for (country of countryLib; track country) {
          <mat-option [value]="country.code">{{ country.code }} ({{ country.prefix }})</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" subscriptSizing="dynamic">
      <mat-label>{{ 'COMMON.PHONE' | translate }}</mat-label>
      <input matInput type="phone" [formField]="phoneForm.phoneNumber" />
    </mat-form-field>
  </div>

  @if (phoneForm.phoneNumber().dirty() && phoneForm.phoneNumber().errors().length) {
    <mat-error>{{ phoneForm.phoneNumber().errors()[0].message | translate }}</mat-error>
  }
</div>
